<div #container class="slider-container">
  <div #slider class="slider" [ngClass]="sliderClass()">
    <div class="slide" *ngFor="let slide of getCards(); index as i" [style]="slideStyle(i)">
      <app-hotel-cell
        *ngIf="hotel"
        [card]="slide"
        [cardsLength]="cardsLength"
        [firstArray]="firstArray"
        (clickOn)="emitClick($event)"
      />
      <div *ngIf="!hotel && !imagesCards">
        <app-offer-cell
          *ngIf="i % 2 == 0"
          [card]="slide"
          [soloSlide]="soloSlide"
          [hover]="i == activeNumber && tab"
        />
        <app-offer-cell
          *ngIf="i % 2 == 1"
          [card]="slide"
          [soloSlide]="soloSlide"
          [hover]="(i == activeNumber || i == 0) && tab"
        />
      </div>
      <div *ngIf="!hotel && imagesCards" [style]="slide.flex" class="slide-img">
        <div *ngIf="slide.cloud != undefined" class="slide-img-cloud"
             [style]="'top: ' + slide.cloud.top + '%;' + 'left: ' + slide.cloud.left + '%;'">
          <div class="slide-img-cloud-top" >
            <app-texts
              [texts]="[
                {text: slide.cloud.title, }
              ]"
            />
            <div *ngIf="slide.cloud.button" class="slide-img-cloud-top-icon">
              <img src="app/assets/icons/arrow-bold.svg" alt="arrow" >
            </div>
          </div>
          <div class="slide-img-cloud-workspace" [style]="'padding-top: ' + (slide.cloud.paddingTop ?? 0) + 'px;'">
            <app-texts [texts]="slide.cloud.text"/>
          </div>
        </div>
        <app-image-slider
          [card]="slide"
        />
      </div>
    </div>
  </div>
</div>
